export default {
    showStickyKpiPosition: 80,
}